import { forwardRef, type Ref, type SVGProps } from "react";
const IconTextColorOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5 24h5.18l1.695-5.017h8.253L21.822 24H27L19.12 2h-6.23zm13.904-8.648-2.81-8.325h-.178l-2.814 8.325z"
      clipRule="evenodd"
    />
    <path fill="currentColor" d="M4 26h24a2 2 0 1 1 0 4H4a2 2 0 1 1 0-4" />
  </svg>
);
const ForwardRef = forwardRef(IconTextColorOutlineSVG);
ForwardRef.displayName = "IconTextColorOutline";
export { ForwardRef as IconTextColorOutline };
